import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import type { SerializedConsent } from '@enmon/commons/lib/enmon';

export class UserMyConsentsApiClient extends BaseApiClient {
  constructor() {
    super('api/users/me/consents');
  }

  public getAll(signal: RequestOptions['signal']): Promise<SerializedConsent[] | null> {
    return this.http.get('', { signal });
  }

  public grant({ consentId }: { consentId: SerializedConsent['_id'] }): Promise<SerializedConsent | null> {
    return this.http.put(`${consentId}/grant`, {});
  }
}
